export default __webpack_public_path__ + "static/media/glint.5feab31b.svg";